module.exports = __webpack_public_path__ + "img/logo.076ae1f4.png";